import { DashboardAppNirvanaDataProvider } from '../dataProvider/DashboardAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';

export class DashboardAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, DashboardAppNirvanaDataProvider);
  }
}
